/* TDS cart page + cart drawer (Oct 2026). Loaded site-wide from snippets/tds-floating-cart.
   - Every [data-tdsc] block (cart page or drawer) updates itself through the Cart AJAX API
     with Section Rendering, so nothing reloads.
   - The theme's own cart drawer is replaced: cart icon, floating cart button and theme
     add-to-cart buttons open the TDS drawer instead. */
(function(){
  if(window.__tdsCart)return;window.__tdsCart=true;
  var DRAWER_SECTION='tds-cart-drawer';

  function rootOf(el){return el&&el.closest?el.closest('[data-tdsc]'):null}
  function err(r,m){if(!r)return;var e=r.querySelector('[data-error]');if(e){e.textContent=m||'';e.hidden=!m}}
  function syncCount(c){
    document.querySelectorAll('.cart-count').forEach(function(el){el.textContent=el.classList.contains('cart-count-drawer')?'('+c.item_count+')':c.item_count});
    document.querySelectorAll('[data-tds-fcart-count]').forEach(function(b){b.textContent=c.item_count>99?'99+':String(c.item_count);b.hidden=c.item_count===0});
    document.dispatchEvent(new CustomEvent('tds:cart-changed',{detail:c}));
  }
  function swap(r,html){
    if(!r||!html)return r;
    var fresh=new DOMParser().parseFromString(html,'text/html').querySelector('[data-tdsc]');
    if(!fresh)return r;
    var open=[].map.call(r.querySelectorAll('.tdsc-acc details'),function(d){return d.open});
    var note=r.querySelector('[data-note]'),noteVal=note?note.value:null;
    var sc=r.querySelector('.tdsd-scroll'),scTop=sc?sc.scrollTop:0;
    r.innerHTML=fresh.innerHTML;
    r.querySelectorAll('.tdsc-acc details').forEach(function(d,i){if(open[i])d.open=true});
    var n2=r.querySelector('[data-note]');if(n2&&noteVal!==null)n2.value=noteVal;
    var sc2=r.querySelector('.tdsd-scroll');if(sc2)sc2.scrollTop=scTop;
    init(r);
    return r;
  }
  function sectionsUrl(r){return r.classList.contains('tdsc--drawer')?'/':window.location.pathname}
  function post(r,url,body){
    var sid=r.dataset.section;body.sections=[sid];body.sections_url=sectionsUrl(r);
    r.classList.add('is-busy');err(r,'');
    return fetch(url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json','X-TDS-Cart':'1'},body:JSON.stringify(body)})
      .then(function(res){return res.json().then(function(j){if(!res.ok)throw new Error(j.description||j.message||'Something went wrong. Please try again.');return j})})
      .then(function(j){
        var html=j.sections&&j.sections[sid];if(html)swap(r,html);
        // keep the other view (page vs drawer) in step
        if(!r.classList.contains('tdsc--drawer')){var d=document.querySelector('.tdsd [data-tdsc]');if(d)d.dataset.stale='1'}
        return fetch('/cart.js',{credentials:'same-origin'}).then(function(x){return x.json()}).then(syncCount);
      })
      .catch(function(e){err(r,e.message)})
      .finally(function(){r.classList.remove('is-busy')});
  }

  document.addEventListener('click',function(e){
    var r=rootOf(e.target);if(!r)return;
    var q=e.target.closest('[data-qty]');
    if(q){var line=q.closest('[data-key]');post(r,'/cart/change.js',{id:line.dataset.key,quantity:parseInt(q.dataset.qty,10)});return}
    var a=e.target.closest('[data-add]');
    if(a){a.setAttribute('aria-busy','true');post(r,'/cart/add.js',{items:[{id:parseInt(a.dataset.add,10),quantity:1}]});return}
    var sp=e.target.closest('[data-plan]');
    if(sp){var lk=sp.closest('[data-key]').dataset.key,pid=sp.dataset.plan;post(r,'/cart/change.js',{id:lk,quantity:parseInt(sp.dataset.q,10)||1,selling_plan:pid?parseInt(pid,10):null});return}
    var u=e.target.closest('[data-upgrade]');
    if(u){var key=u.closest('[data-key]').dataset.key,qty=parseInt(u.dataset.q,10)||1,vid=parseInt(u.dataset.upgrade,10),from=u.dataset.from||'';
      r.classList.add('is-busy');
      fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','X-TDS-Cart':'1'},body:JSON.stringify({id:key,quantity:0})})
        .then(function(){return post(r,'/cart/add.js',{items:[from?{id:vid,quantity:qty,properties:{_tds_from:from}}:{id:vid,quantity:qty}]})});return}
    if(e.target.closest('[data-apply]')){var c=r.querySelector('[data-code]');var v=(c.value||'').trim();if(!v){err(r,'Enter a discount code first.');c.focus();return}
      window.location.href='/discount/'+encodeURIComponent(v)+'?redirect='+encodeURIComponent('/cart')}
  });
  document.addEventListener('keydown',function(e){
    if(e.key==='Enter'&&e.target.matches&&e.target.matches('[data-tdsc] [data-code]')){e.preventDefault();var b=rootOf(e.target).querySelector('[data-apply]');if(b)b.click()}
  });
  var nt;document.addEventListener('input',function(e){if(!e.target.matches||!e.target.matches('[data-tdsc] [data-note]'))return;clearTimeout(nt);var v=e.target.value;nt=setTimeout(function(){fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({note:v})})},600)});

  function countdown(r){
    var el=r.querySelector('[data-countdown]');if(!el)return;
    var cut=parseInt(r.dataset.cutoff,10)||14;
    var now=new Date(new Date().toLocaleString('en-US',{timeZone:'Australia/Melbourne'}));
    var c=new Date(now);c.setHours(cut,0,0,0);
    var wd=now.getDay()>0&&now.getDay()<6;
    if(wd&&now<c){var m=Math.ceil((c-now)/6e4);var h=Math.floor(m/60),mm=m%60;
      el.innerHTML='Order within <b>'+(h?h+'h ':'')+String(mm).padStart(h?2:1,'0')+'m</b> for next-day dispatch';el.hidden=false}
    else{el.hidden=true}
  }
  var io;
  function sticky(r){
    if(r.classList.contains('tdsc--drawer'))return;
    var bar=r.querySelector('[data-sticky]'),main=r.querySelector('[data-checkout-main]');
    if(io){io.disconnect();io=null}
    if(!bar||!main||!('IntersectionObserver' in window))return;
    io=new IntersectionObserver(function(en){var vis=en[0].isIntersecting||en[0].boundingClientRect.top<0;bar.classList.toggle('is-on',!vis);bar.setAttribute('aria-hidden',vis?'true':'false');var b=bar.querySelector('button');if(b)b.tabIndex=vis?-1:0});
    io.observe(main);
  }
  function init(r){countdown(r);sticky(r)}
  function initAll(){document.querySelectorAll('[data-tdsc]').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAll);else initAll();
  setInterval(function(){document.querySelectorAll('[data-tdsc]').forEach(countdown)},30000);
  window.addEventListener('pageshow',function(e){if(e.persisted&&document.querySelector('.tdsc:not(.tdsc--drawer)'))window.location.reload()});

  /* ---------------- drawer ---------------- */
  var shell=null,lastFocus=null,loading=false;
  function build(){
    if(shell)return shell;
    shell=document.createElement('div');shell.className='tdsd';shell.setAttribute('aria-hidden','true');
    shell.innerHTML='<div class="tdsd-overlay" data-tdsd-close></div><div class="tdsd-panel" role="dialog" aria-modal="true" aria-labelledby="tdsd-title" tabindex="-1"><div class="tdsd-loading"><i></i></div></div>';
    document.body.appendChild(shell);
    shell.addEventListener('click',function(e){if(e.target.closest('[data-tdsd-close]'))close()});
    shell.addEventListener('keydown',function(e){
      if(e.key==='Escape'){close();return}
      if(e.key!=='Tab')return;
      var f=[].filter.call(shell.querySelectorAll('a[href],button:not([disabled]),input,textarea,[tabindex]:not([tabindex="-1"])'),function(x){return x.offsetParent!==null});
      if(!f.length)return;var first=f[0],last=f[f.length-1];
      if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus()}
      else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus()}
    });
    return shell;
  }
  function load(){
    var panel=shell.querySelector('.tdsd-panel');
    loading=true;
    return fetch('/?section_id='+DRAWER_SECTION,{credentials:'same-origin'}).then(function(r){return r.text()}).then(function(html){
      var fresh=new DOMParser().parseFromString(html,'text/html').querySelector('[data-tdsc]');
      if(!fresh)throw new Error('no drawer');
      panel.innerHTML='';panel.appendChild(document.importNode(fresh,true));
      init(panel.querySelector('[data-tdsc]'));
    }).finally(function(){loading=false});
  }
  function open(){
    if(document.querySelector('.tdsc:not(.tdsc--drawer)'))return;
    build();lastFocus=document.activeElement;
    var panel=shell.querySelector('.tdsd-panel');
    if(!panel.querySelector('[data-tdsc]')||panel.querySelector('[data-tdsc]').dataset.stale)panel.innerHTML='<div class="tdsd-loading"><i></i></div>';
    shell.classList.add('is-open');shell.setAttribute('aria-hidden','false');
    document.documentElement.classList.add('tdsd-lock');
    load().catch(function(){window.location.href='/cart'});
    setTimeout(function(){panel.focus({preventScroll:true})},50);
  }
  function close(){
    if(!shell)return;
    shell.classList.remove('is-open');shell.setAttribute('aria-hidden','true');
    document.documentElement.classList.remove('tdsd-lock');
    if(lastFocus&&lastFocus.focus)lastFocus.focus({preventScroll:true});
  }
  window.TDSCartDrawer={open:open,close:close};

  // cart icon, floating cart button and any theme "open mini cart" trigger open the TDS drawer
  document.addEventListener('click',function(e){
    var t=e.target.closest&&e.target.closest('#cart-icon-bubble,.bls-minicart-action:not(.close-cart),[data-tds-fcart]');
    if(!t||t.closest('.tdsd'))return;
    if(document.querySelector('.tdsc:not(.tdsc--drawer)'))return; // on the cart page the link just stays put
    e.preventDefault();e.stopImmediatePropagation();open();
  },true);

  // theme add-to-cart buttons: let them add, then show the TDS drawer instead of the theme's
  var addedAt=0;
  var _fetch=window.fetch;
  window.fetch=function(input,init){
    var url=typeof input==='string'?input:(input&&input.url)||'';
    var p=_fetch.apply(this,arguments);
    if(/\/cart\/add(\.js)?(\?|$)/.test(url)){
      var fromTds=false;try{var hd=init&&init.headers;fromTds=!!(hd&&(hd['X-TDS-Cart']||(hd.get&&hd.get('X-TDS-Cart'))))}catch(x){}
      if(!fromTds)p.then(function(res){if(res.ok){addedAt=Date.now();setTimeout(open,150)}}).catch(function(){});
    }
    return p;
  };
  if('MutationObserver' in window){
    new MutationObserver(function(){
      var h=document.documentElement;
      if(h.classList.contains('hside_opened')&&Date.now()-addedAt<2500){h.classList.remove('hside_opened')}
    }).observe(document.documentElement,{attributes:true,attributeFilter:['class']});
  }
  /* ---------------- product cards: size chips + Add to cart ---------------- */
  document.addEventListener('click',function(e){
    var chip=e.target.closest&&e.target.closest('[data-card-size]');
    if(chip){
      var card=chip.closest('[data-tds-card]');if(!card)return;
      [].forEach.call(chip.parentNode.querySelectorAll('[data-card-size]'),function(b){b.setAttribute('aria-pressed',b===chip?'true':'false')});
      var pr=card.querySelector('[data-card-price]');
      if(pr){pr.innerHTML='<span class="p-now">'+chip.dataset.p+'</span>'+(chip.dataset.c?'<span class="p-was">'+chip.dataset.c+'</span>':'')}
      var ab=card.querySelector('[data-card-add]');if(ab)ab.dataset.cardAdd=chip.dataset.v;
      return;
    }
    var btn=e.target.closest&&e.target.closest('[data-card-add]');
    if(!btn)return;
    e.preventDefault();
    if(btn.getAttribute('aria-busy')==='true')return;
    var c=btn.closest('[data-tds-card]'),old=c&&c.querySelector('.tds-card-err');if(old)old.remove();
    btn.setAttribute('aria-busy','true');
    _fetch('/cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:parseInt(btn.dataset.cardAdd,10),quantity:1}]})})
      .then(function(res){return res.json().then(function(j){if(!res.ok)throw new Error(j.description||j.message||'Could not add this item.');return j})})
      .then(function(){
        btn.classList.add('is-added');
        var d=document.querySelector('.tdsd [data-tdsc]');if(d)d.dataset.stale='1';
        return _fetch('/cart.js',{credentials:'same-origin'}).then(function(x){return x.json()}).then(syncCount).then(function(){
          setTimeout(open,650);
          setTimeout(function(){btn.classList.remove('is-added')},2200);
        });
      })
      .catch(function(er){if(c){var p=document.createElement('p');p.className='tds-card-err';p.setAttribute('role','alert');p.textContent=er.message;c.querySelector('.tds-card-body').appendChild(p)}})
      .finally(function(){btn.removeAttribute('aria-busy')});
  });

  document.documentElement.classList.add('tdsd-ready');
})();
